export const RisksTypes = [ 'declared_value', 'insurance', ] as const;
export type RisksTypes = typeof RisksTypes[number];

export interface RisksInterface {
   type: RisksTypes;
   amount: number;
   currency: string;

   dangerousGoods?: boolean;
}

export class Risks implements RisksInterface {
   type: RisksTypes;
   amount: number;
   currency: string;

   dangerousGoods?: boolean;

   constructor( risks?: Risks ) {
      if ( risks?.type ) {
         this.type = risks?.type;
         this.amount = risks?.amount;
         this.currency = risks?.currency;
      }

      if ( risks?.dangerousGoods ) {
         this.dangerousGoods = risks?.dangerousGoods;
      }
   }
}

import { FormGroup, FormControl } from '@angular/forms';
export function risksGroup( risks: any = {} ): FormGroup {
   const rg = new FormGroup({
      type: new FormControl( risks['type'] ),
      amount: new FormControl({ value: risks['amount'], disabled: true }),
      currency: new FormControl({ value: risks['currency'], disabled: true }),
      dangerousGoods: new FormControl( risks?.dangerousGoods ),
   });

   if (rg.get('type').value == null || rg.get('type').value == '') {
      rg.get('amount').disable();
      rg.get('currency').reset();
      rg.get('currency').disable();
   }

   return rg;
}
